// Sets up `window.App` + the ActionCable consumer DURING the ESM import
// phase. Must be imported (directly or transitively) before any code
// that reads `window.App` — including the channel-registration files,
// which add methods to App.
//
// Splitting this out from `cable.js` matters because static `import`
// statements in cable.js were hoisted above its own `window.App = App`
// assignment, so the channel files ran before App existed. Putting the
// setup in its own module lets ESM's dependency-order evaluation
// guarantee App is populated before the channels register on it.

import * as ActionCable from '@rails/actioncable'

const App = {}
App.Cable = ActionCable.createConsumer('/websocket')
console.debug('ActionCable loaded')

if (window.App) {
  Object.assign(window.App, App)
} else {
  window.App = App
}

export default window.App
